package com.klantenstop.web.pages.admin.settings

import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class SettingsViewModel : ViewModel(), SettingsContract {

    private val _state = MutableStateFlow(SettingsContract.State())
    override val state: StateFlow<SettingsContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<SettingsContract.Effect>()
    override val effect: SharedFlow<SettingsContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(SettingsContract.Intent.LoadSettings)
    }

    override fun sendIntent(intent: SettingsContract.Intent) = coroutineScope.launch {
        when (intent) {
            is SettingsContract.Intent.LoadSettings -> loadSettings()
            is SettingsContract.Intent.UpdateSiteName -> updateState { it.copy(siteName = intent.name) }
            is SettingsContract.Intent.UpdateSiteDescription -> updateState { it.copy(siteDescription = intent.description) }
            is SettingsContract.Intent.UpdateContactEmail -> updateState { it.copy(contactEmail = intent.email) }
            is SettingsContract.Intent.UpdateContactPhone -> updateState { it.copy(contactPhone = intent.phone) }
            is SettingsContract.Intent.UpdateSessionTimeout -> updateState { it.copy(sessionTimeout = intent.timeout) }
            is SettingsContract.Intent.UpdatePasswordMinLength -> updateState { it.copy(passwordMinLength = intent.length) }
            is SettingsContract.Intent.UpdateDefaultSearchRadius -> updateState { it.copy(defaultSearchRadius = intent.radius) }
            is SettingsContract.Intent.UpdateMaxSearchRadius -> updateState { it.copy(maxSearchRadius = intent.radius) }
            is SettingsContract.Intent.UpdateReviewModeration -> updateState { it.copy(reviewModerationEnabled = intent.enabled) }
            is SettingsContract.Intent.UpdateMinimumRating -> updateState { it.copy(minimumRating = intent.rating) }
            is SettingsContract.Intent.SaveSettings -> saveSettings()
        }
    }

    override fun emitEffect(effect: SettingsContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (SettingsContract.State) -> SettingsContract.State) {
        _state.update(block)
    }

    private suspend fun loadSettings() {
        updateState { it.copy(isLoading = true) }

        // TODO: Implement load settings logic
        // val settings = settingsRepo.getSettings()
        // updateState {
        //     it.copy(
        //         siteName = settings.siteName,
        //         siteDescription = settings.siteDescription,
        //         contactEmail = settings.contactEmail,
        //         contactPhone = settings.contactPhone,
        //         sessionTimeout = settings.sessionTimeout,
        //         passwordMinLength = settings.passwordMinLength,
        //         defaultSearchRadius = settings.defaultSearchRadius,
        //         maxSearchRadius = settings.maxSearchRadius,
        //         reviewModerationEnabled = settings.reviewModerationEnabled,
        //         minimumRating = settings.minimumRating,
        //         isLoading = false
        //     )
        // }

        updateState { it.copy(isLoading = false) }
    }

    private suspend fun saveSettings() {
        updateState { it.copy(isSaving = true) }

        // TODO: Implement save settings logic
        // val currentState = state.value
        // val success = settingsRepo.updateSettings(
        //     siteName = currentState.siteName,
        //     siteDescription = currentState.siteDescription,
        //     contactEmail = currentState.contactEmail,
        //     contactPhone = currentState.contactPhone,
        //     sessionTimeout = currentState.sessionTimeout,
        //     passwordMinLength = currentState.passwordMinLength,
        //     defaultSearchRadius = currentState.defaultSearchRadius,
        //     maxSearchRadius = currentState.maxSearchRadius,
        //     reviewModerationEnabled = currentState.reviewModerationEnabled,
        //     minimumRating = currentState.minimumRating
        // )
        //
        // if (success) {
        //     emitEffect(SettingsContract.Effect.ShowSuccess("Settings saved successfully"))
        // } else {
        //     emitEffect(SettingsContract.Effect.ShowError("Failed to save settings"))
        // }

        updateState { it.copy(isSaving = false) }
    }
}

